<template>
  <div>
    <main class="help-center">
      <card title="Filters">
        <div class="row">
          <div class="col-md-2 pr-md-1">
            <el-select
              v-model="filters.category"
              clearable
              filterable
              class="mb-4"
              placeholder="Category"
              @change="getQuestionsListEvent"
            >
              <el-option
                v-for="category in categoriesList"
                :key="category.id"
                :label="category.title.en"
                :value="category.id"
              />
            </el-select>
          </div>
          <div class="col-md-2 pr-md-1">
            <el-select
              v-model="filters.illness"
              clearable
              filterable
              class="mb-4"
              placeholder="Illness"
              @change="getQuestionsListEvent"
            >
              <el-option
                v-for="illness in illnesses"
                :key="illness.id"
                :label="illness.name.en"
                :value="illness.alias.en"
              />
            </el-select>
          </div>
          <div class="col-md-2 pr-md-1">
            <el-select
              v-model="filters.operation"
              clearable
              filterable
              class="mb-4"
              placeholder="Operation"
              @change="getQuestionsListEvent"
            >
              <el-option
                v-for="operation in operations"
                :key="operation.id"
                :label="operation.name.en"
                :value="operation.alias.en"
              />
            </el-select>
          </div>
          <div class="col-md-2 pr-md-1">
            <el-select
              v-model="filters.diagnostic"
              clearable
              filterable
              class="mb-4"
              placeholder="Diagnostic"
              @change="getQuestionsListEvent"
            >
              <el-option
                v-for="diagnostic in diagnostics"
                :key="diagnostic.id"
                :label="diagnostic.name.en"
                :value="diagnostic.alias.en"
              />
            </el-select>
          </div>
          <div class="col-md-2 pr-md-1">
            <el-select
              v-model="filters.illnessKind"
              clearable
              filterable
              class="mb-4"
              placeholder="Illness kind"
              @change="getQuestionsListEvent"
            >
              <el-option
                v-for="kind in illnessKinds"
                :key="kind.id"
                :label="kind.name.en"
                :value="kind.alias.en"
              />
            </el-select>
          </div>
          <div class="col-md-2 px-md-1">
            <base-button @click="clearFilters()">Clear filters</base-button>
          </div>
        </div>
      </card>
      <card>
        <div class="help-center__title">
          <span>List of questions</span>
          <router-link :to="{ path: 'create' }" class="btn btn-primary"
            >Create</router-link
          >
        </div>
        <el-table :data="questionsList.questions">
          <el-table-column
            fixed
            :prop="`question[${item.language}]`"
            :label="`Title ${item.language.toUpperCase()}`"
            v-for="item in titleLanguages"
            :key="item.language"
          />
          <el-table-column width="100">
            <template slot-scope="scope">
              <div class="cell">
                <button
                  class="btn btn-primary btn-link"
                  @click="handleEdit(scope.row.id)"
                >
                  <i class="tim-icons icon-pencil"></i>
                </button>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="200">
            <template slot-scope="scope">
              <div class="cell">
                <button
                  class="btn btn-danger"
                  @click="handleDelete(scope.row.id)"
                >
                  Delete
                </button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </card>
    </main>
    <el-pagination
      v-if="questionsList.metadata.total_count"
      style="text-align:center"
      :page-size="30"
      layout="prev, pager, next"
      :total="questionsList.metadata.total_count"
      :current-page="page"
      @current-change="nextPage"
      class="text-center mt-20"
      background
    ></el-pagination>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    page: 1,
    filters: {
      illness: null,
      operation: null,
      diagnostic: null,
      illnessKind: null,
      category: null
    }
  }),
  computed: {
    ...mapState("cmsApiCatalogs", [
      "domains",
      "operations",
      "illnesses",
      "diagnostics",
      "illness-kinds",
      "countries"
    ]),
    ...mapState("helpCenter", ["questionsList"]),
    ...mapState("helpCenterCategories", ["categoriesList"]),
    offset() {
      return this.page === 1 ? 0 : (this.page - 1) * 30;
    },
    titleLanguages() {
      return this.domains.filter(
        domain => domain.language === "ru" || domain.language === "en"
      );
    },
    illnessKinds() {
      return this["illness-kinds"];
    }
  },
  methods: {
    ...mapActions("helpCenter", ["getQuestionsList", "deleteQuestion"]),
    ...mapActions("helpCenterCategories", ["getCategoriesList"]),
    ...mapActions("cmsApiCatalogs", [
      "getDomains",
      "getOperations",
      "getIllnesses",
      "getCountries",
      "getDiagnostics",
      "getIllnessKinds"
    ]),
    getQuestionsListEvent() {
      this.$store.dispatch("setLoader", true);
      const relation_keys = [];
      const relation_values = [];
      const params = {
        offset: this.offset
      };

      Object.entries(this.filters).forEach(([key, value]) => {
        if (value) {
          if (key === "category") {
            params.category_id = value;
          } else {
            relation_keys.push(key);
            relation_values.push(value);
          }
        }
      });
      if (relation_keys.length) params.relation_keys = relation_keys;
      if (relation_values.length) params.relation_values = relation_values;
      return this.getQuestionsList(params).finally(() =>
        this.$store.dispatch("setLoader", false)
      );
    },
    nextPage(page) {
      this.page = page;
      this.getQuestionsListEvent();
    },

    handleEdit(id) {
      this.$router.push({ name: "edit", params: { id } });
    },

    async handleDelete(id) {
      this.$store.dispatch("setLoader", true);
      try {
        await this.deleteQuestion(id);
        await this.getQuestionsListEvent();
        this.$notify({ type: "success", title: "Question deleted" });
      } catch (e) {
        this.$notify({ type: "warning", title: "Error" });
      } finally {
        this.$store.dispatch("setLoader", false);
      }
    },
    clearFilters() {
      this.filters.illness = null;
      this.filters.operation = null;
      this.filters.diagnostic = null;
      this.filters.illnessKind = null;
      this.getQuestionsListEvent();
    }
  },
  created() {
    this.getQuestionsListEvent();
    this.getDomains();
    this.getOperations();
    this.getIllnesses({ perPage: 1500 });
    this.getCountries({ perPage: 1500 });
    this.getDiagnostics({ perPage: 1500 });
    this.getIllnessKinds({ perPage: 1500 });
    this.getCategoriesList();
  }
};
</script>
